'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Dataset;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/** @category DataView */

/* eslint-disable react/no-unused-prop-types */


function Dataset() {
  return _react2.default.createElement('div', null);
}

Dataset.propTypes = {
  /** The type of chart for the specific dataset, it can be different than the chart type */
  type: _propTypes2.default.oneOf(['bar', 'horizontalBar', 'line', 'radar', 'pie', 'doughnut', 'polarArea', 'bubble']),

  /** The values to represent in the chart */
  values: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,

  /** The label for the dataset which appears in the legend and tooltips. */
  title: _propTypes2.default.string,

  /** The fill color under the line. */
  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),

  /** The color of the line, if left undefined, the backgroundColor is used */
  borderColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),

  /** The ID of the group to which this dataset belongs to
   * (when stacked, each group will be a separate stack) */
  stack: _propTypes2.default.string,

  /** Whether to fill the area under the line */
  fill: _propTypes2.default.bool
};
Dataset.defaultProps = {
  title: 'Dataset',
  type: undefined,
  backgroundColor: undefined,
  borderColor: undefined,
  stack: undefined,
  fill: false
};